import {Paper} from "@/types/paper";
import {Characteristic} from "@/types/Characteristic";

export enum PageType {
  Content = 0 ,
  Blog = 1,
}

export interface ArticleCategory {
  title: string,
  slug: string,
}
export interface Tag {
  title: string,
  slug: string,
}


export interface Article {
    title: string,
    category: ArticleCategory,
    tags: Tag[],
    content: string,
    summary: string,
    type: PageType,
    image: string,
    slug: string,
}
